export default "__VITE_ASSET__cc30a73d__"